import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  category: string;
  features: {
    name: string;
    starter: boolean | string;
    professional: boolean | string;
    enterprise: boolean | string;
  }[];
}

const ComparisonTable = () => {
  const comparisonData: ComparisonFeature[] = [
    {
      category: "AI Implementatie",
      features: [
        { name: "Chatbot integratie", starter: true, professional: true, enterprise: true },
        { name: "Social media automatisering", starter: "Basis", professional: "Geavanceerd", enterprise: "Premium" },
        { name: "E-mail automatisering", starter: true, professional: true, enterprise: true },
        { name: "Workflow automatisering", starter: false, professional: true, enterprise: true },
        { name: "Custom AI modellen", starter: false, professional: false, enterprise: true }
      ]
    },
    {
      category: "Support & Training",
      features: [
        { name: "E-mail support", starter: true, professional: true, enterprise: true },
        { name: "Telefoon support", starter: false, professional: true, enterprise: true },
        { name: "Dedicated account manager", starter: false, professional: false, enterprise: true },
        { name: "Onboarding training", starter: "1 sessie", professional: "3 sessies", enterprise: "Onbeperkt" },
        { name: "Maandelijkse reviews", starter: false, professional: true, enterprise: true }
      ]
    },
    {
      category: "Integraties",
      features: [
        { name: "Standaard integraties", starter: "3", professional: "10", enterprise: "Onbeperkt" },
        { name: "API toegang", starter: false, professional: true, enterprise: true },
        { name: "Custom integraties", starter: false, professional: false, enterprise: true },
        { name: "Webhooks", starter: false, professional: true, enterprise: true },
        { name: "White-label oplossingen", starter: false, professional: false, enterprise: true }
      ]
    },
    {
      category: "Analytics & Rapportage",
      features: [
        { name: "Basis analytics", starter: true, professional: true, enterprise: true },
        { name: "Geavanceerde rapportage", starter: false, professional: true, enterprise: true },
        { name: "Custom dashboards", starter: false, professional: false, enterprise: true },
        { name: "Export functionaliteit", starter: false, professional: true, enterprise: true },
        { name: "Real-time monitoring", starter: false, professional: true, enterprise: true }
      ]
    }
  ];

  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="CheckIcon" size={20} className="text-success mx-auto" />
      ) : (
        <Icon name="XMarkIcon" size={20} className="text-muted-foreground mx-auto" />
      );
    }
    return <span className="text-sm font-medium text-foreground">{value}</span>;
  };

  return (
    <section className="py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Gedetailleerde vergelijking
          </h2>
          <p className="text-lg text-muted-foreground">
            Bekijk alle functies en mogelijkheden per pakket
          </p>
        </div>

        <div className="max-w-6xl mx-auto overflow-x-auto">
          <div className="min-w-[800px]">
            <div className="grid grid-cols-4 gap-4 mb-6 sticky top-0 bg-background z-10 py-4">
              <div className="font-display font-bold text-foreground"></div>
              <div className="text-center">
                <p className="font-display font-bold text-foreground mb-1">Starter</p>
                <p className="text-sm text-muted-foreground">€1.250/mnd</p>
              </div>
              <div className="text-center">
                <p className="font-display font-bold text-primary mb-1">Professional</p>
                <p className="text-sm text-muted-foreground">€2.500/mnd</p>
              </div>
              <div className="text-center">
                <p className="font-display font-bold text-foreground mb-1">Enterprise</p>
                <p className="text-sm text-muted-foreground">Op maat</p>
              </div>
            </div>

            {comparisonData.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-8">
                <div className="glassmorphic rounded-2xl p-6">
                  <h3 className="text-lg font-display font-bold text-foreground mb-4">
                    {category.category}
                  </h3>
                  <div className="space-y-3">
                    {category.features.map((feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className="grid grid-cols-4 gap-4 items-center py-3 border-b border-border last:border-b-0"
                      >
                        <div className="text-sm text-foreground">{feature.name}</div>
                        <div className="text-center">{renderValue(feature.starter)}</div>
                        <div className="text-center">{renderValue(feature.professional)}</div>
                        <div className="text-center">{renderValue(feature.enterprise)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;